import React from "react";
import { motion } from "framer-motion";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import CustomInput from "Common/CustomInput/CustomInput";
import SuperAccordion from "Components/SuperAccordion/SuperAccordion";
import PropTypes from "prop-types";

const CostShare = ({
  planData,
  planIndex,
  insuranceSectionsOpen,
  onToggleInsuranceSection,
  handleChange,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className="border rounded-lg p-4"
    >
      <div
        className="flex items-center justify-between cursor-pointer py-2"
        onClick={() => onToggleInsuranceSection("costShare")}
      >
        <h3 className="text-lg font-medium text-gray-900">Cost Share</h3>
        {insuranceSectionsOpen.costShare ? (
          <FiChevronUp className="text-gray-500" />
        ) : (
          <FiChevronDown className="text-gray-500" />
        )}
      </div>
      <SuperAccordion show={insuranceSectionsOpen.costShare}>
        <div className="grid grid-cols-12 gap-4 mt-4">
          <div className="col-span-12 md:col-span-3">
            <CustomInput
              name="copay"
              data-nested={`patientPlan.${planIndex}.copay`}
              isNumeric
              maxFloat={1}
              onChange={handleChange}
              value={planData?.copay || 0}
              label="Copay"
              isFloat
              placeholder="0.00"
              toolTip="Fixed amount paid for a covered service"
              prefixIcon={<span className="text-gray-500 ">$</span>}
            />
          </div>
          <div className="col-span-12 md:col-span-3">
            <CustomInput
              name="deductible"
              data-nested={`patientPlan.${planIndex}.deductible`}
              isNumeric
              maxFloat={1}
              onChange={handleChange}
              value={planData?.deductible || 0}
              label="Deductible"
              isFloat
              placeholder="0.00"
              toolTip="Amount paid out of pocket before insurance begins to pay"
              prefixIcon={<span className="text-gray-500 ">$</span>}
            />
          </div>
          <div className="col-span-12 md:col-span-3">
            <CustomInput
              name="coInsurance"
              data-nested={`patientPlan.${planIndex}.coInsurance`}
              isNumeric
              maxFloat={1}
              onChange={handleChange}
              value={planData?.coInsurance || 0}
              label="Co-insurance"
              isFloat
              placeholder="0"
              toolTip="Percentage of costs paid after deductible is met"
              suffixIcon={<span className="text-gray-500 pr-2">%</span>}
            />
          </div>
          <div className="col-span-12 md:col-span-3">
            <CustomInput
              name="outOfPocketMax"
              data-nested={`patientPlan.${planIndex}.outOfPocketMax`}
              isNumeric
              maxFloat={1}
              onChange={handleChange}
              value={planData?.outOfPocketMax || 0}
              label="Out Of Pocket Max"
              isFloat
              placeholder="0.00"
              toolTip="Maximum amount you'll pay for covered services in a plan year"
              prefixIcon={
                <span className="text-gray-500 font-medium">$</span>
              }
            />
          </div>
        </div>
      </SuperAccordion>
    </motion.div>
  );
};

CostShare.propTypes = {
  planData: PropTypes.object,
  planIndex: PropTypes.number.isRequired,
  insuranceSectionsOpen: PropTypes.object.isRequired,
  onToggleInsuranceSection: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default CostShare;
